import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useCart } from '../../hooks/useCart';
import { useMobile } from '../../hooks/useMobile';

import { ROUTE_PATH } from '../../route/utils';

import { ReactComponent as Cart } from '../../icons/cart_bold.svg';

import './cart-total.scss';

import { Currency } from '../../utils/currency/Currency';

const CartTotal = ({ total }) => {
  const navigate = useNavigate();
  const isMobile = useMobile();
  const { cartOpen, setCartOpen } = useCart();

  const handleOpenCart = () => {
    if (isMobile) {
      setCartOpen(false);
      return navigate(ROUTE_PATH.CART, { replace: true });
    } else {
      setCartOpen(!cartOpen);
    }
  };

  return (
    <div className={`cart-total ${total > 0 ? 'cart-total--active' : ''}`} onClick={handleOpenCart}>
      <Cart width={18} height={18} />
      <Currency value={total} />
    </div>
  );
};

export default CartTotal;
